// virtual-keyboard.directive.ts
import { Directive, HostListener, ElementRef } from '@angular/core';
import { VirtualKeyboardService } from './virtual-keyboard.service';
import {
  Platform,
} from '@ionic/angular';

@Directive({ selector: '[appVirtualKeyboard]' })
export class VirtualKeyboardDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    private vkbService: VirtualKeyboardService,
    private platform: Platform,
  ) {}

  @HostListener('focus')
  onFocus() {
    if (this.platform.is('electron')) {
      this.vkbService.setActiveInput(this.el.nativeElement);
      this.vkbService.syncInput(this.el.nativeElement?.value ?? '');
    }
  }

  @HostListener('input')
  onInput() {
    if (this.platform.is('electron')) {
      this.vkbService.syncInput(this.el.nativeElement?.value ?? '');
    }
  }

  @HostListener('blur')
  onBlur() {
    if (this.platform.is('electron')) {
      this.vkbService.hide();
    }
  }
}
